import { render, staticRenderFns } from "./clickable-tile.vue?vue&type=template&id=5345ef90&scoped=true"
import script from "./clickable-tile.vue?vue&type=script&lang=js"
export * from "./clickable-tile.vue?vue&type=script&lang=js"
import style0 from "./clickable-tile.vue?vue&type=style&index=0&id=5345ef90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345ef90",
  null
  
)

export default component.exports